module.exports = __webpack_public_path__ + "img/icon-expand-c56fd8d3.svg";